
























































import { Component, Vue } from "vue-property-decorator";
let elevideo: any = null;

@Component({
  components: {},
})
export default class Home extends Vue {
  public playUrl =
    "https://static.996yinqing.com/offical/static/video/996m2.mp4";
  public activeIndex = 0;
  public videoList = [
    {
      name: "996传奇引擎：宣传视频",
      baseUrl: "https://static.996yinqing.com/offical/static/video/996m2.mp4",
      converImg: require("../../../../assets/video/996m2.jpg"),
      id: 0,
    },
    {
      name: "996传奇3引擎：宣传视频",
      baseUrl:
        "https://static.996yinqing.com/offical/static/video/202401121337cq3.mp4",
      converImg: require("../../../../assets/video/chuanqi3.png"),
      id: 1,
    },
    {
      name: "996传奇引擎：新PC宣传视频",
      baseUrl:
        "https://static.996yinqing.com/offical/static/app/1675406486000_h6mxr.m4v",
      converImg: require("../../../../assets/video/newpc.png"),
      id: 2,
    },
    {
      name: "复古服案例：云游传奇",
      baseUrl:
        "https://static.996yinqing.com/offical/static/video/sixVideo.mp4",
      converImg: require("../../../../assets/video/yunyouchuanqi.jpg"),
      id: 3,
    },
    {
      name: "轻变服案例：原始传奇",
      baseUrl:
        "https://static.996yinqing.com/offical/static/video/qingbianban.mp4",
      converImg: require("../../../../assets/video/qingbianfufm.jpg"),
      id: 4,
    },
    {
      name: "超变服案例：王者之路",
      baseUrl:
        "https://static.996yinqing.com/offical/static/video/wangzhezhilu.mp4",
      converImg: require("../../../../assets/video/wangzhezhilu.jpg"),
      id: 5,
    },
    {
      name: "合击服案例：热血合击",
      baseUrl:
        "https://static.996yinqing.com/offical/static/video/hejiban.mp4",
      converImg: require("../../../../assets/video/hejifufm.jpg"),
      id: 6,
    },
    {
      name: "传世引擎案例：铜锤传世",
      baseUrl:
        "https://static.996yinqing.com/offical/static/app/1672930046000_ZKEin.mp4",
      converImg: require("../../../../assets/video/tongchui.jpg"),
      id: 7,
    },
    {
      name: "传世引擎案例：龙腾传世",
      baseUrl:
        "https://static.996yinqing.com/offical/static/video/fiveVideo.mp4",
      converImg: require("../../../../assets/video/fiveVideo.jpg"),
      id: 8,
    },
  ];
  public mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.findvideocover(this.videoList[0]);
        elevideo = document.getElementById("videoPlay");
        elevideo.addEventListener(
          "ended",
          () => {
            // 结束
            this.nextVideo();
          },
          false
        );
      }, 100);
    });
  }

  public prepVideo() {
    const index = this.activeIndex;
    if (index == 0) {
      this.findvideocover(this.videoList[this.videoList.length - 1]);
    } else {
      this.findvideocover(this.videoList[index - 1]);
    }
  }
  public nextVideo() {
    const index = this.activeIndex;
    this.findvideocover(this.videoList[(index + 1) % this.videoList.length]);
  }
  public selectVideo(row) {
    this.findvideocover(row);
  }
  public findvideocover(row) {
    this.playUrl = row.baseUrl;
    this.activeIndex = row.id;
    this.scrollHeight(row);
    const video: any = document.getElementById("videoPlay");
    video.src = row.baseUrl;
    video.load();
    const playPromise = video.play(0);
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          video.play(0);
        })
        .catch(() => {
          // console.log("出错了")
        });
    }
  }
  public scrollHeight(row) {
    const count = row.id > 2 ? (row.id - 2) * 138 : 0;
    (this as any).$refs.video.scrollTo({
      top: count,
      behavior: "smooth",
    });
  }
  public beforeDestroy() {
    elevideo = null;
  }
}
